import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomepageEventBanner } from '../../core/models/homepage-event-banner.model';
import { CxIconComponent } from '../icon/cx-icon.component';
import { BannerImageComponent } from '../banner-image/banner-image.component';
import { eventDetailsRoute } from '../../core/util/event-route.util';

@Component({
  selector: 'app-homepage-event-banner',
  standalone: true,
  imports: [CommonModule, RouterModule, CxIconComponent, BannerImageComponent],
  templateUrl: './homepage-event-banner.component.html',
  styleUrl: './homepage-event-banner.component.scss',
})
export class HomepageEventBannerComponent implements OnChanges, OnInit {
  @Input() banner: HomepageEventBanner | null = null;
  @Input() showFramingAction = false;
  @Output() adjustFraming = new EventEmitter<void>();

  activeBanner: HomepageEventBanner | null = null;
  eventPath: Array<string | number> = ['/'];

  get supportingText(): string {
    return this.activeBanner?.status === 'LIVE'
      ? 'Open the event to learn more and sign in to watch.'
      : 'Open the event for details and RSVP.';
  }

  ngOnChanges(): void {
    this.activeBanner = this.banner ? { ...this.banner } : null;
    this.updateEventPath();
  }

  ngOnInit(): void {
    if (!this.activeBanner && this.banner) {
      this.activeBanner = { ...this.banner };
      this.updateEventPath();
    }
  }

  private updateEventPath(): void {
    this.eventPath = this.activeBanner
      ? eventDetailsRoute({
          id: this.activeBanner.eventId,
          byProfileTagName: this.activeBanner.hostTag,
        }) ?? ['/events', this.activeBanner.eventId]
      : ['/'];
  }

  formatEventTime(banner: HomepageEventBanner): string {
    try {
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZone: banner.timezoneId,
        timeZoneName: 'short',
      }).format(new Date(banner.startsAt));
    } catch {
      return banner.startsAt;
    }
  }
}
